<template>
    <div>
        <textarea :value="value" v-on:input="onChangeEvent" :maxlength="maxLength" :disabled="disabled" :placeholder="placeholder">
        </textarea>
    </div>
</template>

<script>
    export default {
        name: "BTextInput",
        props: {
            value: String,
            placeholder: String,
            maxLength: Number,
            disabled:Boolean,
        },
        computed: {
        },
        methods: {
            onChangeEvent(event) {
                this.$emit("input", event.target.value);
            }
        }
    }
</script>

<style scoped>
    * {
        outline: none;
    }

    textarea:focus {
        border: 1px solid #0171A3;;
    }

    textarea{
        padding: 1em;
        width: 100%;
        height: 100%;
        font-size: 14px;
        resize: none;
        border-radius: 3px;
        font-family:Source Han Sans CN;
        background:#FFFFFF
    }

</style>